import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import {
  Lightning,
  Eye,
  EyeSlash,
  EnvelopeSimple,
  Lock,
} from "@phosphor-icons/react";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate("/dashboard");
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-4"
      style={{
        background: `linear-gradient(to bottom, rgba(10,10,10,0.9), rgba(10,10,10,0.95)), url('https://static.prod-images.emergentagent.com/jobs/dffc03f0-ae24-43ea-957d-761902304813/images/d094b271fa49f257b88c62b9f54b391226b31b77cd1c9230fa72f37bdee06d45.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 bg-[#00E676] rounded-2xl flex items-center justify-center mb-4">
            <Lightning size={40} weight="fill" className="text-black" />
          </div>
          <h1 className="text-2xl font-bold tracking-tight text-white">
            EBIKE CONTROL
          </h1>
          <p className="text-[#A1A1AA] text-center mt-1">
            Sistema de Montagem e Rastreabilidade
          </p>
        </div>

        {/* Login Form */}
        <form
          onSubmit={handleSubmit}
          className="card p-6 space-y-4"
          data-testid="login-form"
        >
          <h2 className="text-xl font-bold text-center mb-4 text-white">
            Entrar
          </h2>

          {error && (
            <div
              className="bg-[#FF3B30]/10 border border-[#FF3B30]/30 rounded-lg p-3 text-[#FF3B30] text-sm"
              data-testid="login-error"
            >
              {error}
            </div>
          )}

          <div className="space-y-2">
            <label className="text-sm text-[#A1A1AA]">Email</label>
            <div className="relative">
              <EnvelopeSimple
                size={20}
                className="absolute left-4 top-1/2 -translate-y-1/2 text-[#A1A1AA]"
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field !pl-12"
                placeholder="seu@email.com"
                required
                data-testid="login-email-input"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-sm text-[#A1A1AA]">Senha</label>
            <div className="relative">
              <Lock
                size={20}
                className="absolute left-4 top-1/2 -translate-y-1/2 text-[#A1A1AA]"
              />
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-field !pl-12 !pr-12"
                placeholder="Sua senha"
                required
                data-testid="login-password-input"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-[#A1A1AA] hover:text-white"
              >
                {showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary mt-6"
            data-testid="login-submit-button"
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
